import React from 'react';
import { useOrgChartContext } from '@/contexts/OrgChartContext';
import { NotFound } from '@/pages/others/NotFound';

type HasTeamGuardProps = {
  children: React.ReactNode;
};

/**
 * Blocks access to a route for users who have no team members.
 * Renders NotFound when myTeam is empty.
 */
export const HasTeamGuard: React.FC<HasTeamGuardProps> = ({ children }) => {
  const { myTeam, isLoading } = useOrgChartContext();

  if (isLoading) return null;

  if (!myTeam || myTeam.length === 0) {
    return <NotFound />;
  }

  return <>{children}</>;
};
